import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'

function ControlNew() {
  const [car, setCar] = useState({})

  return <Outlet context={{ car, setCar }} />
}

export default ControlNew
